import {
  IonButton,
  IonButtons,
  IonContent,
  IonHeader,
  IonIcon,
  IonModal,
  IonTitle,
  IonToolbar,
} from '@ionic/react';
import { close } from 'ionicons/icons';
import { useTranslation } from 'react-i18next';
import {
  PaintingPartDetail,
  PaintingPartDetailProps,
} from './painting-part-detail';

export interface PaintingPartDetailModalProps extends PaintingPartDetailProps {
  isOpen?: boolean;
  onDismiss: () => void;
  presentingEl?: HTMLElement;
}

const PaintingPartDetailModal = (props: PaintingPartDetailModalProps) => {
  const { presentingEl, isOpen, onDismiss } = props;

  const { i18n } = useTranslation();

  return (
    <IonModal
      presentingElement={presentingEl}
      isOpen={isOpen}
      canDismiss={true}
      onDidDismiss={onDismiss}
    >
      <IonHeader>
        <IonToolbar>
          <IonButtons slot={'start'}>
            <IonButton onClick={onDismiss}>
              <IonIcon icon={close} size="large" />
            </IonButton>
          </IonButtons>
          <IonTitle>{i18n.t('common:part_details')}</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent>
        <PaintingPartDetail
          afterSave={() => {
            onDismiss();
          }}
        />
      </IonContent>
    </IonModal>
  );
};

export { PaintingPartDetailModal };
